import React from 'react'
import { CitationCopy } from '@chegg-wt/core/types/copy'
import * as Styled from './styled'

interface CitationListEmptyProps {
  copy: CitationCopy
}

export const CitationListEmptyContainer: React.FC<CitationListEmptyProps> = ({
  copy,
}) => (
  <Styled.EmptyStateContainer>
    <Styled.EmptyStateText>{copy.emptyCitationList}</Styled.EmptyStateText>
    <Styled.EmptyStateCreateCitationText>
      {copy.emptyCitationCreateLink}
    </Styled.EmptyStateCreateCitationText>
  </Styled.EmptyStateContainer>
)
